import React from 'react';
import ScreenLayout from '../../layout/ScreenLayout/ScreenLayout';
import { ActiveMessengerContainer } from '../../components/ActiveMessengerContainer/ActiveMessengerContainer';

const ActiveInstagramScreen = () => {
    return (
        <ScreenLayout>
            <ActiveMessengerContainer messenger={'instagram'} />
        </ScreenLayout>
    );
};

export default ActiveInstagramScreen;
